export const translations = {
  sv: {
    introMessage: `Välj ombud du vill agera som?`,
  },
  en: {
    introMessage: `Which customer number do you want to handle today?`,
  },
  da: {
    introMessage: `Hvilket kundenummer vil du håndtere i dag?`,
  },
  no: {
    introMessage: `Hvilket kundenummer ønsker du å håndtere i dag?`,
  },
  fi: {
    introMessage: `Mitä asiakasnumeroa haluat käsitellä tänään?`,
  },
  de: {
    introMessage: `Welche Kundennummer möchten Sie heute bearbeiten?`,
  },
};
